module.exports = __webpack_public_path__ + "cd07467305d7b59aaf1d8b77a72081d2.svg";